import React from 'react';
import "./Toast.scss";

const Toast = ({
  children,
}) => {
  return (
    <div className="Toast">
      {children}
    </div>
  );
};

export default Toast;
